import { render, staticRenderFns } from "./Foracti.vue?vue&type=template&id=3e2ac596&scoped=true"
import script from "./Foracti.vue?vue&type=script&lang=js"
export * from "./Foracti.vue?vue&type=script&lang=js"
import style0 from "./Foracti.vue?vue&type=style&index=0&id=3e2ac596&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ac596",
  null
  
)

export default component.exports